import axios from "@/plugins/axios";
import CryptoAES from "@/plugins/crypto-aes";

export default {
    getRefreshToken({ username, password, usertype }) {
        let headers = {
            Authorization: "Basic " + CryptoAES.encrypt(new Buffer(`${username}:${password}`).toString("base64")),
            usertype,
        };
        if (!headers.usertype) delete headers.usertype;

        return axios.get(`/api/auth/refreshToken`, { headers }).then((result) => result.data);
    },
    getAccessToken(refreshToken) {
        let headers = {
            Authorization: `Bearer ${refreshToken}`,
        };

        return axios.get(`/api/auth/accessToken`, { headers }).then((result) => result.data);
    },
};
